import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatComponentsModule} from "../../mat-components/mat-components.module";
import {FormsModule} from "@angular/forms";
import {MATERIAL_MODULES} from "../../app.const";
import {PipesModule} from "../../pipes/pipes.module";
import {FilesModule} from "../../files/files.module";
import {IndustriesEditComponent} from "./industries-edit/industries-edit.component";
import {IndustriesViewComponent} from "./industries-view/industries-view.component";
import {IndustriesComponent} from "./industries.component";
import {RouterModule} from "@angular/router";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatMenuModule,
        MatComponentsModule,
        FormsModule,
        ...MATERIAL_MODULES,
        PipesModule,
        FilesModule,
        RouterModule,
        DirectivesModule
    ],
    declarations: [
        IndustriesComponent,
        IndustriesEditComponent,
        IndustriesViewComponent
    ]
})
export class IndustriesModule { }
